import { Suspense } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';

import { AppLoader, AppSnackbarAlertsComponent } from '@sternum/web/components';
import { router } from '@sternum/web/routes';

import './fonts.css';
import './services/i18n';

import { MainThemeProvider } from './components/theme/main';
import { FeatureFlagsProvider } from './services/featureFlags';
import { queryClient } from './services/react-query';
import { trpc, trpcClient } from './services/trpc';
import { store } from './store';
import { WithDevMockServer } from './WithDevMockServer';

import { GlobalCss } from './App.style';

export function App() {
  return (
    <ReduxProvider store={store}>
      <MainThemeProvider>
        <GlobalCss />
        <Suspense fallback={<AppLoader />}>
          <trpc.Provider client={trpcClient} queryClient={queryClient}>
            <FeatureFlagsProvider>
              <QueryClientProvider client={queryClient}>
                <HelmetProvider>
                  <WithDevMockServer>
                    <AppSnackbarAlertsComponent />
                    <RouterProvider router={router} future={{ v7_startTransition: true }} />
                  </WithDevMockServer>
                </HelmetProvider>
              </QueryClientProvider>
            </FeatureFlagsProvider>
          </trpc.Provider>
        </Suspense>
      </MainThemeProvider>
    </ReduxProvider>
  );
}
